import { __rest } from '../../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/material/styles';
import React__default from 'react';
import { getImageAssetUrl } from '../../../utils/assetUtils.js';
import { TABLET_SCREEN_SIZE, MOBILE_SCREEN_SIZE } from '../../../utils/constants/Constants.js';

const StyledDialogContent = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    textAlign: 'center',
    margin: '0 auto',
    position: 'relative',
    width: 'fit-content',
    gap: 10,
    '.img_container': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '0 auto',
    },
    '.logo': {
        width: 51,
        height: 51,
    },
    '.title': {
        color: `${theme.vars.palette.primary.main} !important`,
        marginTop: 10,
        marginBottom: 10,
        fontSize: 24,
        fontWeight: 'bold',
        [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
            fontSize: 22,
        },
        [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
            fontSize: 22,
        },
    },
    '.second-title': {
        color: `${theme.vars.palette.primary.main} !important`,
        fontSize: 20,
        fontWeight: 600,
        [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
            fontSize: 18,
            fontWeight: 600,
        },
        [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
            fontSize: 18,
            fontWeight: 600,
        },
    },
    '.subtitle': {
        color: `${theme.vars.palette.primary.main} !important`,
        fontSize: 18,
        fontWeight: 500,
        maxWidth: 380,
        [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
            fontSize: 14,
        },
        [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
            fontSize: 14,
        },
    },
    '.phone-input-container': {
        margin: '12px auto',
        'div:first-of-type': {
            alignItems: 'center',
        },
    },
    '.arrow-text': {
        justifyContent: 'center',
    },
    '.video-container': {
        maxWidth: 314,
        maxHeight: 414,
    },
    '.share-container': {
        paddingTop: 10,
    },
}));
const ProductPageDialogContent = (_a) => {
    var { imageUrl, imageSize = 51, showIcon, title, secondTitle, subtitle, children } = _a, props = __rest(_a, ["imageUrl", "imageSize", "showIcon", "title", "secondTitle", "subtitle", "children"]);
    return (React__default.createElement(StyledDialogContent, { className: "styled-dialog-content", sx: Object.assign({ paddingBottom: '55px' }, props.sx) },
        imageUrl && (React__default.createElement("div", { className: "img_container" },
            React__default.createElement("img", { loading: "lazy", src: imageUrl, alt: "", style: { width: imageSize, height: imageSize, objectFit: 'contain' } }))),
        showIcon && (React__default.createElement("div", null,
            React__default.createElement("img", Object.assign({ loading: "lazy", src: getImageAssetUrl('brandclub-b-logo.webp'), alt: "", className: "logo" }, props.iconProps)))),
        title && React__default.createElement("div", { className: "title" }, title),
        secondTitle && React__default.createElement("div", { className: "second-title" }, secondTitle),
        subtitle && React__default.createElement("div", { className: "subtitle" }, subtitle),
        children));
};

export { ProductPageDialogContent, StyledDialogContent };
//# sourceMappingURL=ProductPageDialogContent.js.map
